import React, { useState } from 'react';
/* 🎯 Path locked at 3 levels */
import { DisplayToggleControl, AddEntryControl } from '../../../common/components/SEC_UI_StatusControls';

export default function SEC_03_GenericManagerView({ config, schema = [], data = [], loading, onUpdate, onAdd, onShowSubList }) {
    const [newRow, setNewRow] = useState({});
    const [editingIdx, setEditingIdx] = useState(null); 
    const [editData, setEditData] = useState({});
    const [expandedRowId, setExpandedRowId] = useState(null); 

    // Filter dynamic columns from C# metadata
    const displayColumns = schema.filter(col => 
        !col.key.toLowerCase().endsWith('id') && col.key !== 'isActive'
    );

    const startEdit = (idx, row) => {
        setEditingIdx(idx);
        setEditData({ ...row }); 
    };

    const handleSave = (idx) => {
        onUpdate(idx, editData);
        setEditingIdx(null);
    };

    const handleToggleSubList = (row) => {
        const isOpening = expandedRowId !== row.id;
        setExpandedRowId(isOpening ? row.id : null);
        if (isOpening && onShowSubList) {
            onShowSubList(row); // Triggers the generic fetch for links
        }
    };

    if (loading) return <div className="p-4 small text-muted italic">Syncing {config.title}...</div>;

    return (
        <div className="p-4 animate__animated animate__fadeIn">
            <div className="mb-4 p-3 bg-light border-start border-4 border-primary shadow-sm">
                <h5 className="fw-bold text-dark">{config.title}</h5>
                <p className="text-muted small mb-0">{config.description}</p>
            </div>

            <div className="table-responsive bg-white rounded shadow-sm border">
                <table className="table table-hover align-middle mb-0">
                    <thead className="table-light">
                        <tr>
                            <th className="ps-3 text-center" style={{ width: '60px' }}>EDIT</th>
                            {displayColumns.map(col => (
                                <th key={col.key} className="ps-3 text-uppercase small fw-bold text-muted">{col.label}</th>
                            ))}
                            <th style={{ width: '100px' }}>STATUS</th>
                            <th className="text-end pe-3" style={{ width: '120px' }}>ACTIONS</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, idx) => {
                            const isEditing = editingIdx === idx;
                            const isExpanded = expandedRowId === row.id;

                            return (
                                <React.Fragment key={row.id || idx}>
                                    <tr className={isEditing ? "table-warning border-primary" : ""}>
                                        <td className="ps-3 text-center">
                                            <input 
                                                type="checkbox" 
                                                className="form-check-input shadow-none"
                                                checked={isEditing}
                                                onChange={() => isEditing ? setEditingIdx(null) : startEdit(idx, row)}
                                            />
                                        </td>
                                        {displayColumns.map(col => (
                                            <td key={col.key} className="ps-3">
                                                {isEditing ? (
                                                    <input 
                                                        type="text" 
                                                        className="form-control form-control-sm shadow-none"
                                                        value={editData[col.key] || row[col.key] || ''}
                                                        onChange={(e) => setEditData({...editData, [col.key]: e.target.value})}
                                                    />
                                                ) : (
                                                    <span className="small text-dark">{row[col.key]}</span>
                                                )}
                                            </td>
                                        ))}
                                        <td className="text-center">
                                            {/* 🎯 UI Toggle for Sub-list visibility */}
                                            <DisplayToggleControl 
                                                isVisible={isExpanded} 
                                                onToggle={() => handleToggleSubList(row)} 
                                            />
                                        </td>
                                        <td className="text-end pe-3">
                                            {isEditing && (
                                                <button className="btn btn-success btn-xs px-2 fw-bold shadow-sm" onClick={() => handleSave(idx)}>
                                                    SAVE
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                    
                                    {/* Sub-list Panel Placeholder for Generic Links */}
                                    {isExpanded && (
                                        <tr className="bg-light shadow-inner">
                                            <td colSpan={displayColumns.length + 3} className="p-0">
                                                <div className="p-3 border-bottom border-top bg-white-50">
                                                    <small className="text-muted italic">Loading associated {config.relationship?.label || 'items'}...</small>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            );
                        })}

                        {/* 🎯 FIXED FOOTER: AddEntryControl is now wrapped in a <td> to fix Hydration Error */}
                        <tr className="bg-light border-top-2">
                            <td className="text-center text-muted border-end"><i className="bi bi-plus-lg"></i></td>
                            {displayColumns.map(col => (
                                <td key={col.key} className="ps-3">
                                    <input 
                                        type="text" 
                                        className="form-control form-control-sm border-primary-subtle shadow-none" 
                                        placeholder={`New ${col.label}...`}
                                        value={newRow[col.key] || ''}
                                        onChange={(e) => setNewRow({...newRow, [col.key]: e.target.value})}
                                    />
                                </td>
                            ))}
                            <td></td>
                            <td className="text-end pe-3">
                                <AddEntryControl onAdd={() => { onAdd(newRow); setNewRow({}); }} entityName={config.title} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}